import * as Sentry from "@sentry/react";

// Inicialización de Sentry
export function initSentry() {
  const environment = import.meta.env.MODE || 'development';
  console.log('environment', environment)
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: environment,
    // Performance Monitoring
    tracesSampleRate: 1.0, // Captura el 100% de las transacciones
    // Session Replay
    replaysSessionSampleRate: 0.1, // Captura el 10% de las sesiones
    replaysOnErrorSampleRate: 1.0, // Captura el 100% de las sesiones con errores
    //racePropagationTargets: ["localhost", /^https:/ / yourserver.io / api / ],
    // Capturar todos los errores
    beforeSend(event) {
      // Asegurarse de que todos los errores se envíen a Sentry
      //console.log('Enviando error a Sentry:', event);
      return event;
    },
  });

  // Configurar un manejador de errores global para capturar errores no manejados
  window.onerror = function(message, source, lineno, colno, error) {
    console.error('Error capturado por window.onerror:', error || message);
    Sentry.captureException(error || message);
    return false; // Permite que el error se propague
  };

  // Capturar promesas rechazadas no manejadas
  window.addEventListener('unhandledrejection', function(event) {
    console.error('Promesa rechazada no manejada:', event.reason);
    Sentry.captureException(event.reason);
  });
}

// Función para capturar errores manualmente
export function captureError(error, context = {}) {
  console.error('Error capturado manualmente:', error, context);
  Sentry.captureException(error, {
    tags: context
  });
}

// Función para capturar mensajes
export function captureMessage(message, level = 'info', context = {}) {
  console.log('Mensaje capturado en Sentry:', message, level, context);
  Sentry.captureMessage(message, {
    level,
    tags: context
  });
}

// Función para registrar solicitudes HTTP en Sentry
export function logRequest(method, url, params = {}, body = {}) {
  // Generar un ID único para la solicitud
  const requestId = 'request-' + Date.now() + '-' + Math.random().toString(36).substring(2, 9);
  
  // Añadir breadcrumb para la solicitud
  Sentry.addBreadcrumb({
    category: 'http',
    message: `${method} ${url}`,
    level: 'info',
    data: {
      url,
      method,
      params,
      body,
      requestId
    }
  });

  // Registrar la solicitud como un evento
  Sentry.captureMessage(`${method} ${url}`, 'info', {
    url,
    method,
    params,
    body,
    requestId
  });

  return requestId;
}

// Función para finalizar una transacción de solicitud HTTP
export function finishRequest(requestId, status = 'success') {
  if (requestId) {
    // Registrar el resultado de la solicitud
    Sentry.captureMessage(`Request completed: ${status}`, 'info', {
      requestId,
      status
    });
  }
}